var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "c-card",
        { attrs: { title: "승인 상세" } },
        [
          _c(
            "template",
            { slot: "card-button" },
            [
              _c(
                "q-btn-group",
                { attrs: { outline: "" } },
                [
                  _vm.editable && !_vm.param.disabled
                    ? _c("c-btn", {
                        attrs: { label: "승인", icon: "approval" },
                      })
                    : _vm._e(),
                  _vm.editable && !_vm.param.disabled
                    ? _c("c-btn", { attrs: { label: "LBLSAVE", icon: "save" } })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c("template", { slot: "card-detail" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-radio", {
                  attrs: {
                    disabled: _vm.param.disabled,
                    editable: _vm.editable,
                    comboItems: _vm.approvItems,
                    label: "승인여부",
                    name: "col1",
                  },
                  model: {
                    value: _vm.mocApproval.col1,
                    callback: function ($$v) {
                      _vm.$set(_vm.mocApproval, "col1", $$v)
                    },
                    expression: "mocApproval.col1",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-datepicker", {
                  attrs: {
                    disabled: true,
                    editable: _vm.editable,
                    label: "승인일",
                    name: "col2",
                  },
                  model: {
                    value: _vm.mocApproval.col2,
                    callback: function ($$v) {
                      _vm.$set(_vm.mocApproval, "col2", $$v)
                    },
                    expression: "mocApproval.col2",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass:
                  "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
              },
              [
                _c("c-textarea", {
                  attrs: {
                    disabled: _vm.param.disabled,
                    editable: _vm.editable,
                    label: "승인근거",
                    name: "col3",
                  },
                  model: {
                    value: _vm.mocApproval.col3,
                    callback: function ($$v) {
                      _vm.$set(_vm.mocApproval, "col3", $$v)
                    },
                    expression: "mocApproval.col3",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c("c-upload", {
                  attrs: { editable: _vm.editable && !_vm.param.disabled },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }